export default __webpack_public_path__ + "static/media/female1.ba3f6b87.png";